import { ChallengeTargetOperatorEnum } from '../../../common/enum/challenge-target/challenge-target-operator.enum';
import { CubeTimeDimensionGranularity } from '../../../common/enum/cube-time-dimension-granularity.enum';
import { Weekdays } from '../../../common/enum/weekdays/weekdays.enum';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';
import { SharedOrgMetricsRequestDto } from '../common/shared-org-metrics-request.dto';
import { AccountMetricInsightsMetricType } from './account-metrics-insights-metric-type.enum';
import { MetricValueType } from './metric-value-type';

// TODO: ... define discriminated union interfaces for different metric types
export interface GetChallengeInsightProgressSummaryRequestDto {
  params: {
    startDate: string;
    endDate: string;
    userIds: string[];
    challengeTargetId: string;
    challengeTargetValue: number;
    granularity: CubeTimeDimensionGranularity;
    metricType: AccountMetricInsightsMetricType;
    challengeTargetOperator?: ChallengeTargetOperatorEnum;
    segments?: Weekdays[];
    type?: MetricValueType; // duration/interactions based on metrictype and key (only used if key is present)
    key?: string; // meeting type
    entityId?: string; // app id if metric type time in meeting
  } & SharedOrgMetricsRequestDto;
  config: CubeRequestConfig;
}
